<template src="./template.html"></template>
<style lang="scss" src="./styles.scss" scoped></style>

<script>
import FallbackAvatar from '@/components/ui/FallbackAvatar'

export default {
  name: 'GroupInvitationOverlay',
  components: {
    FallbackAvatar,
  },
  props: {
    group: Object,
    isOpen: Boolean,
    type: String,
  },
  computed: {
    opened: {
      set() {
        this.$emit('onCloseOverlay')
      },
      get() {
        return this.isOpen
      },
    },
  },
  methods: {
    acceptInvitation() {
      if (this.group.membership_id) {
        this.$emit('accept', this.group.membership_id, this.group.type)
      } else {
        this.$emit('accept', this.group.id, this.type)
      }
      this.$emit('onCloseOverlay')
    },
    declineInvitation() {
      if (this.group.membership_id) {
        this.$emit('decline', this.group.membership_id, this.group.type)
      } else {
        this.$emit('decline', this.group.id, this.type)
      }
      this.$emit('onCloseOverlay')
    },
  },
}
</script>
